//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import { ActionButton } from 'unison';

import makeAngularReactController from '@react-bridge/angular-react-widget';

// This component is wrapped by an anchor in UIA modal which handles the download
const UniversalImageActionsDownloadButton = () => {
  return <ActionButton iconName='download' label='Download' />;
};

angular.module('curalate').component('universalImageActionsDownloadButton', {
  controller: makeAngularReactController(
    <UniversalImageActionsDownloadButton />,
  ),
});
